import React from 'react'

import Grid from '../../../../components/pdf/Grid'
import Image from '../../../../components/pdf/Image'
import Separator from '../../../../components/pdf/Separator'

const Header = () => {
  return (
    <>
      <Grid justify="right">
        <Image src="/btime-logo-roxo.png" maxWidth={150} ignoreFixedSize />
      </Grid>
      <Separator weight={15} />
    </>
  )
}

export default Header
